import { getTerminalId } from "./terminalIdentity";

export const TERMINAL_SOUND_CHANGED_EVENT = "menuzyka:terminal-sound-changed";
export const TERMINAL_SOUND_TEST_EVENT = "menuzyka:terminal-sound-test";

export const DEFAULT_TERMINAL_SOUND_SETTINGS = Object.freeze({
  enabled: true,
  newOrderEnabled: true,
  waiterRequestEnabled: true,
  paymentEnabled: true,
});

export const terminalSoundStorageKey = restaurantId =>
  `terminal-sound-alerts:${String(restaurantId || "").toLowerCase()}:${getTerminalId()}`;

export const normalizeTerminalSoundSettings = value => ({
  enabled: value?.enabled ?? value?.soundAlertsEnabled ?? true,
  newOrderEnabled: value?.newOrderEnabled ?? value?.newOrderSoundEnabled ?? true,
  waiterRequestEnabled: value?.waiterRequestEnabled ?? value?.waiterRequestSoundEnabled ?? true,
  paymentEnabled: value?.paymentEnabled ?? value?.paymentSoundEnabled ?? true,
});

export const readTerminalSoundPreference = (restaurantId, fallback = DEFAULT_TERMINAL_SOUND_SETTINGS) => {
  const saved = localStorage.getItem(terminalSoundStorageKey(restaurantId));
  if (saved == null) return normalizeTerminalSoundSettings(fallback);
  if (saved === "1" || saved === "0") return normalizeTerminalSoundSettings({ enabled: saved === "1" });
  try { return normalizeTerminalSoundSettings(JSON.parse(saved)); }
  catch { return normalizeTerminalSoundSettings(fallback); }
};

export const writeTerminalSoundPreference = (restaurantId, settings, notify = false) => {
  const value = normalizeTerminalSoundSettings(typeof settings === "boolean" ? { enabled: settings } : settings);
  localStorage.setItem(terminalSoundStorageKey(restaurantId), JSON.stringify(value));
  if (notify) window.dispatchEvent(new CustomEvent(TERMINAL_SOUND_CHANGED_EVENT, {
    detail: { restaurantId: String(restaurantId || "").toLowerCase(), settings: value }
  }));
  return value;
};

export const shouldPlayNotificationSound = (settings, type) => {
  const value = normalizeTerminalSoundSettings(settings);
  if (!value.enabled) return false;
  if (["NEW_ORDER", "TAKEAWAY_NEW_ORDER"].includes(type)) return value.newOrderEnabled;
  if (type === "WAITER_REQUEST") return value.waiterRequestEnabled;
  if (["PAYMENT_DONE", "TAKEAWAY_PAYMENT_DONE"].includes(type)) return value.paymentEnabled;
  return false;
};
